/*
 * Judge.me review dates as ДД.ММ.ГГГГ.
 * The Judge.me widget prints dates as plain text in its own format, MM/DD/YYYY (e.g. 09/30/2026), and has no
 * setting for the Russian one. This rewrites those date texts inside Judge.me's widgets and review popup, including
 * reviews it renders later (pagination, popup). Only text that is a date and nothing else is touched.
 */
(function () {
  var SCOPE = '.jdgm-widget, .jdgm-modal';
  var DATE = /^(\s*)(\d{1,2})\/(\d{1,2})\/(\d{4})(\s*)$/;
  var pad = function (n) { return n.length === 1 ? '0' + n : n; };

  function fix(node) {
    var m = DATE.exec(node.nodeValue);
    if (!m) return;
    var a = +m[2], b = +m[3];
    // Judge.me's format is month first; a first number over 12 can only be a day (if the setting is ever changed)
    var day = a > 12 ? m[2] : m[3];
    var month = a > 12 ? m[3] : m[2];
    if (+day > 31 || +month > 12 || (a > 12 && b > 12)) return;
    node.nodeValue = m[1] + pad(day) + '.' + pad(month) + '.' + m[4] + m[5];
  }

  function scan() {
    var roots = document.querySelectorAll(SCOPE);
    for (var i = 0; i < roots.length; i++) {
      var walker = document.createTreeWalker(roots[i], NodeFilter.SHOW_TEXT);
      var n;
      while ((n = walker.nextNode())) if (n.nodeValue.indexOf('/') !== -1) fix(n);
    }
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  }

  function start() {
    scan();
    // Judge.me renders its widgets and the popup with JS, so watch for them (one scan per frame at most)
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
